// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__3nJ02","content":"TermsOfServicePage_content__35JER"};